import React from "react";
import { motion } from "framer-motion";

const partners = [
  { name: "Hafele", logo: "https://via.placeholder.com/120x60/B89D62/FFFFFF?text=Hafele" },
  { name: "Hettich", logo: "https://via.placeholder.com/120x60/B89D62/FFFFFF?text=Hettich" },
  { name: "Ebco", logo: "https://via.placeholder.com/120x60/B89D62/FFFFFF?text=Ebco" },
  { name: "Blum", logo: "https://via.placeholder.com/120x60/B89D62/FFFFFF?text=Blum" },
  { name: "Faber", logo: "https://via.placeholder.com/120x60/B89D62/FFFFFF?text=Faber" },
  { name: "Bosch", logo: "https://via.placeholder.com/120x60/B89D62/FFFFFF?text=Bosch" },
];

export const PartnersSection = () => {
  return (
    <section className="section bg-muted/30">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="uppercase tracking-[0.3em] text-[11px] text-muted-foreground mb-4">
            Our Partners
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-foreground">
            Trusted by Top Brands
          </h2>
        </motion.div>

        <div
          className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-8 items-center"
          data-testid="partners-logos"
        >
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="flex items-center justify-center"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="w-full h-auto opacity-60 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
